import { render } from "./MyCoursesCard.vue?vue&type=template&id=c5fff912"
import script from "./MyCoursesCard.vue?vue&type=script&lang=js"
export * from "./MyCoursesCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__